// Slot machine configuration and static data kept in one place for easy reuse.
export const SYMBOL_ALIASES = [
  'img/paytable_high_1.png',
  'img/paytable_high_2.png',
  'img/paytable_high_3.png',
  'img/paytable_high_4.png',
  'img/paytable_high_5.png',
  'img/paytable_high_6.png',
  'img/paytable_low_1.png',
  'img/paytable_low_2.png',
  'img/paytable_low_3.png',
  'img/paytable_low_4.png',
  'wild',
  'scatter',
  'wrapper_stacks',
];

// Core sizing + layout values.
export const REELS = 5;
export const VISIBLE_ROWS = 5;
export const SYMBOL_SIZE = 150;
export const REEL_WIDTH = 160;

// Asset base paths.
export const BASE_URL = `${process.env.PUBLIC_URL || ''}/WinterLand/resources/`;
export const SPIN_ICON = `${process.env.PUBLIC_URL || ''}/WinterLand/resources/img/Spinbutton.png`;
export const AUTOSPIN_ICON = `${process.env.PUBLIC_URL || ''}/WinterLand/resources/img/autoplay.png`;
export const SOUND_ON_ICON = `${process.env.PUBLIC_URL || ''}/WinterLand/resources/img/ui_icon_sound_on-rst4.png`;
export const SOUND_OFF_ICON = `${process.env.PUBLIC_URL || ''}/WinterLand/resources/img/ui_icon_sound_off-6XJnYQ.png`;

// Audio files.
export const SPIN_SOUND = 'machine_spin-jsWkfg.mp3';
export const STOP_SOUND = 'machine_reel_stops-deipRA.mp3';
export const CLICK_SOUND = 'button_hack3_click-LfevnQ.mp3';
export const BG_MUSIC = 'wang.mp3';

// Game options + assets.
export const AUTOSPIN_ROUNDS = [10, 25, 50, 100, 250, 500, 1000];
export const BET_OPTIONS = [1, 10, 20, 50, 80, 100, 150, 200, 275, 300, 400, 500, 600];
export const WIN_EFFECT_IMAGES = [];

// Symbol ids for readability.
export const WILD_ID = 'wild';
export const SCATTER_ID = 'scatter';
export const WRAPPER_ID = 'wrapper_stacks';

export const PAYTABLE_LABELS = {
  paytable_high_1: 'Revontuli Hehku',
  paytable_high_2: 'Kaamos Kajo',
  paytable_high_3: 'Tunturituuli',
  paytable_high_4: 'Pakkanen Pisto',
  paytable_high_5: 'Kuura Kuningas',
  paytable_high_6: 'Tykky Taika',
  paytable_low_1: 'Lumi Lumo',
  paytable_low_2: 'Kaneli Kipina',
  paytable_low_3: 'Neilikka Naksu',
  paytable_low_4: 'Pipari Pamaus',
  wild: 'Sisu Sulatus',
  scatter: 'Glogi Sade',
  wrapper_stacks: 'Lumipeite',
};

export const getPaytableLabel = (rawId) => {
  if (!rawId) return '';
  const id = String(rawId);
  if (PAYTABLE_LABELS[id]) return PAYTABLE_LABELS[id];
  const match = id.match(/paytable_(high_\d|low_\d)/);
  if (match) {
    const key = `paytable_${match[1]}`;
    return PAYTABLE_LABELS[key] || key.replace(/^paytable_/, '').replace(/_/g, ' ').toUpperCase();
  }
  return id.replace(/^paytable_/, '').replace(/_/g, ' ').toUpperCase();
};

// 35 traditional-ish paylines (5x5)
// Raw paylines (for reference) then filtered to only "touching" lines (adjacent rows).
const RAW_PAYLINES = [
  [0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1],
  [2, 2, 2, 2, 2],
  [3, 3, 3, 3, 3],
  [4, 4, 4, 4, 4],
  [0, 1, 2, 3, 4],
  [4, 3, 2, 1, 0],
  [0, 0, 1, 0, 0],
  [4, 4, 3, 4, 4],
  [0, 1, 1, 1, 2],
  [4, 3, 3, 3, 2],
  [2, 1, 0, 1, 2],
  [2, 3, 4, 3, 2],
  [1, 2, 2, 2, 1],
  [3, 2, 2, 2, 3],
  [1, 1, 0, 1, 1],
  [3, 3, 4, 3, 3],
  [0, 1, 2, 2, 3],
  [4, 3, 2, 2, 1],
  [0, 1, 0, 1, 0],
  [4, 3, 4, 3, 4],
  [1, 0, 1, 2, 3],
  [3, 4, 3, 2, 1],
  [1, 2, 3, 2, 1],
  [3, 2, 1, 2, 3],
  [0, 2, 4, 2, 0],
  [4, 2, 0, 2, 4],
  [2, 0, 2, 4, 2],
  [2, 4, 2, 0, 2],
  [1, 3, 1, 3, 1],
  [3, 1, 3, 1, 3],
  [0, 2, 0, 2, 0],
  [4, 2, 4, 2, 4],
  [1, 3, 4, 3, 1],
  [3, 1, 0, 1, 3],
  [2, 1, 3, 1, 2],
];

// Keep only paylines where each step moves at most one row (symbols are "touching").
export const PAYLINES = RAW_PAYLINES.filter((line) =>
  line.every((row, idx) => idx === line.length - 1 || Math.abs(row - line[idx + 1]) <= 1)
);

// Paytable definitions (including placeholder wild/scatter/wrapper).
export const PAYTABLE = [
  { id: 'paytable_high_1', file: 'paytable_high_1.png', payouts: { 5: 50.0, 4: 5.0, 3: 2.5 } },
  { id: 'paytable_high_2', file: 'paytable_high_2.png', payouts: { 5: 2.5, 4: 1.5, 3: 1.0 } },
  { id: 'paytable_high_3', file: 'paytable_high_3.png', payouts: { 5: 1.25, 4: 0.75, 3: 0.5 } },
  { id: 'paytable_high_4', file: 'paytable_high_4.png', payouts: { 5: 1.25, 4: 0.75, 3: 0.5 } },
  { id: 'paytable_high_5', file: 'paytable_high_5.png', payouts: { 5: 1.0, 4: 0.5, 3: 0.25 } },
  { id: 'paytable_high_6', file: 'paytable_high_6.png', payouts: { 5: 1.0, 4: 0.5, 3: 0.25 } },
  { id: 'paytable_low_1', file: 'paytable_low_1.png', payouts: null },
  { id: 'paytable_low_2', file: 'paytable_low_2.png', payouts: { 5: 0.5, 4: 0.25, 3: 0.1 } },
  { id: 'paytable_low_3', file: 'paytable_low_3.png', payouts: { 5: 0.5, 4: 0.2, 3: 0.05 } },
  { id: 'paytable_low_4', file: 'paytable_low_4.png', payouts: { 5: 0.5, 4: 0.2, 3: 0.05 } },
  { id: WILD_ID, file: 'wild.png', payouts: { 5: 50, 4: 10, 3: 3 } },
  { id: SCATTER_ID, file: 'scatter.png', payouts: null },
  { id: WRAPPER_ID, file: 'wrapper_stacks-eInWPQ.png', payouts: null },
];

// Feature toggles for special symbols. Flip these to include/exclude wilds/scatters/wrappers.
export const FEATURE_TOGGLES = {
  wild: true,
  scatter: false,
  wrapper: true,
};

// Chance to reroll a no-win grid to boost overall win frequency.
// 0.5 means ~50% more wins when base win rate is low.
export const NO_WIN_REROLL_CHANCE = 0.5;
